import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import PageToggleTransition from '../components/transition/PageToggleTransition';
// import AKeepAlive from '@/components/cache/AKeepAlive'
import { mapState } from 'vuex';
export default {
  name: 'BlankView',
  components: {
    PageToggleTransition: PageToggleTransition
    // AKeepAlive
  },
  mounted: function mounted() {
    console.log(this.$route.meta.keepAlive);
    this.page = this.$refs.page;
  },
  computed: _objectSpread({}, mapState('setting', ['multiPage', 'animate']))
};